<template>
  <!-- <v-app> -->
    <main-view />
  <!-- </v-app> -->
</template>
<script>
  import MainView from '@/views/View.vue'
  export default {
    components: {
      MainView,
    },
  }
</script>
